<template lang="">
  <div class="bbs_filter">
    <div class="lft_area">
      <div class="bbs_info">
        <div class="total"><strong>{{ getCurrentCount() }}</strong> / {{ popupListCount }}</div>
      </div>
    </div>
    <div class="rgt_area">
      <div class="bbs_srch">
        <select name="" id="" class="i_sel" v-model="searchType">
          <option
            v-for="option in searchOptions"
            :value="option.value"
          >{{ option.name }}</option>
        </select>
        <input type="text" class="i_txt" name="keyword" v-model="searchWord">
        <button type="button" class="bt_base gray btn_srch" @click="getSearch">검색</button>
      </div>
    </div>
  </div>

  <div class="bbs_list">
    <table class="bbs_tbl">
      <colgroup>
        <col style="width:90px">
        <col style="width:40px">
        <col style="width:auto">
        <col style="width:150px">
        <col style="width:150px">
      </colgroup>
      <thead>
        <tr>
          <th scope="col"><span class="ui_chkbox primary nontxt"><input type="checkbox" name=""><label for=""></label></span></th>
          <th scope="col">번호</th>
          <th scope="col">제목</th>
          <th scope="col">시작일</th>
          <th scope="col">종료일</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(popup, index) in popupList"
        >
        <td>
            <span class="ui_chkbox primary nontxt">
              <input 
                type="checkbox"
                :value="popup.popupSeq"
                v-model="selectedPopups"
              >
              <label for=""></label>
            </span>
          </td>
          <td>{{ index + 1 }}</td>
          <td class="subject type_wider"><a @click="toPopup(popup.popupSeq)">{{ popup.title }}</a></td>
          <td>
            <div class="ui_datetime">
              <span class="date">{{ popup.startDate }}</span>
              <span class="time"></span>
            </div>
          </td>
          <td>
            <div class="ui_datetime">
              <span class="date">{{ popup.endDate }}</span>
              <span class="time"></span>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="paginate">
    <AdminPagination
      :totalPages = "totalPages()"
      :currentPage = "currentPage"
      @changePage = "changePage"
    />

    <div class="rgt_area">
      <button type="button" class="bt_base primary large_h" @click="createPopup">등록</button>
      <button type="button" class="bt_base gray large_h" @click="deleteSelectedPopups">삭제</button>
    </div>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex';
import AdminPagination from '@/components/common/AdminPagination.vue';

const adminPopupModule = 'adminPopupModule'

export default {
  components: {
    AdminPagination
  },

  data () {
    return {
      currentPage: 1,
      selectedPopups: [],

      searchOptions: [
        { name: '전체', value: 'all' }
      ],
      searchType: '',
      searchWord: ''
    }
  },

  methods: {
    ...mapActions(adminPopupModule, [
      'requestPopupList',
      'requestDeletePopups'
    ]),

    createPopup () {
      this.$router.push({ name: "PopupManageCreatePage" })
    },

    toPopup(popupSeq) {
      this.$router.push({
        name: "PopupManageCreatePage",
        query: { popupSeq: popupSeq },
      });
    },

    totalPages() {
      return Math.ceil(this.popupListCount / 10);
    },

    async changePage(page) {
      this.currentPage = page
      const {currentPage, searchType, searchWord} = this
      await this.requestPopupList({currentPage, searchType, searchWord})
    },

    getCurrentCount() {
      const currentFirstCount = (this.currentPage - 1) * 10 + 1
      let currentLastCount = this.currentPage * 10
      if (parseInt(currentLastCount) > parseInt(this.popupListCount)) {
        currentLastCount = this.popupListCount
      }
      return currentFirstCount + '-' + currentLastCount
    },

    toggleAllCheck(isChecked) {
      if (isChecked) {
        this.selectedPopups = []
        for (const popup of this.popupList) {
          this.selectedPopups.push(popup.popupSeq)
        }
      } else {
        this.selectedPopups = []
      }
    },

    async deleteSelectedPopups() {
      if (this.selectedPopups.length === 0) {
        alert('선택된 팝업이 없습니다');
        return;
      }

      const { searchType, searchWord, currentPage } = this;
      const fetchPopups = async (page = 1, type = searchType, word = searchWord, isReset = false) => {
        const params = { currentPage: page, searchType: type, searchWord: word };
        await this.requestPopupList(params);
        if (isReset) {
          this.searchType = 'all';
        }
      };

      await this.requestDeletePopups(this.selectedPopups);
      this.selectedPopups = [];

      await fetchPopups(currentPage);

      if (this.popupList.length === 0 && this.currentPage > 1) {
        this.currentPage -= 1;
        await fetchPopups(this.currentPage);
      }

      if (this.popupList.length === 0 || this.currentPage === 1) {
        this.currentPage = 1;
        this.searchType = '';
        this.searchWord = '';
        await fetchPopups(1, '', '', true);
      }
    },

    async getSearch() {
      if (this.searchWord === '') {
        alert('검색어를 입력해주세요')
        return
      }
      this.currentPage = 1
      const {currentPage, searchType, searchWord} = this
      await this.requestPopupList({currentPage, searchType, searchWord})
    }
  },

  computed: {
    ...mapState(adminPopupModule, [
      'popupList',
      'popupListCount'
    ])
  },

  mounted() {
    const {currentPage, searchType, searchWord} = this
    this.requestPopupList({currentPage, searchType, searchWord})
    this.searchType = 'all'
  }
}
</script>
<style lang="">
    
</style>